import { budgetAlert, BudgetFeedback } from "./BudgetAlert";
import React, { useEffect, useState } from "react";
import { BudgetService } from "_services/budget.service";

export default function BudgetFileUpload({ itemKey, subcategoryKey, fileName = "", onSelectFiles, pendingFiles = [], disabled = false, refreshKey, readOnly = false }) {
    const itemMode = !subcategoryKey;
    const [files, setFiles] = useState(itemKey && fileName ? [{ fileName }] : []);
    const [enabled, setEnabled] = useState(itemMode);
    const [busy, setBusy] = useState(false);
    const [loading, setLoading] = useState(!!subcategoryKey);
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    useEffect(() => {
        if (itemMode) setFiles(fileName ? [{ fileName }] : []);
    }, [itemKey, fileName, itemMode]);
    useEffect(() => {
        let active = true;
        if (subcategoryKey) {
            BudgetService.getSubcategoryFiles(subcategoryKey).then(res => {
                if (!res.data.success) throw new Error("โหลดรายการไฟล์ไม่สำเร็จ");
                if (active) { setFiles(res.data.data); setEnabled(res.data.allowFileUpload); }
            }).catch(e => { if (active) setError(e.response?.data?.message || e.message); })
                .finally(() => { if (active) setLoading(false); });
        }
        return () => { active = false; };
    }, [subcategoryKey, refreshKey]);
    const upload = async e => {
        const input = e.target;
        const selected = Array.from(input.files || []);
        input.value = "";
        if (!selected.length || busy) return;
        setError(""); setMessage("");
        if (selected.length > (itemMode ? 1 : 5) || selected.some(file => !/\.pdf$/i.test(file.name) || file.size > 20 * 1024 * 1024)) {
            setError("เลือก PDF ไม่เกินไฟล์ละ 20 MB (รายการ: 1 ไฟล์ / หมวดย่อย: ครั้งละไม่เกิน 5 ไฟล์)"); return;
        }
        if (itemMode && files.length && !await budgetAlert.confirm("ต้องการแทนที่ไฟล์ PDF เดิมของรายการนี้หรือไม่?")) return;
        if (onSelectFiles) { onSelectFiles(selected); return; }
        setBusy(true);
        try {
            const res = itemKey ? await BudgetService.uploadItemPdf(itemKey, selected[0]) : await BudgetService.uploadSubcategoryPdfs(subcategoryKey, selected);
            if (!res.data.success) throw new Error(res.data.message || "อัปโหลดไม่สำเร็จ");
            setFiles(itemKey ? [{ fileName: res.data.fileName, objectKey: res.data.objectKey }] : res.data.data);
            setMessage("อัปโหลดเรียบร้อยแล้ว");
        } catch (e) { setError(e.response?.data?.message || e.message); }
        finally { setBusy(false); }
    };
    const download = async file => {
        setBusy(true); setError("");
        try {
            const res = itemKey ? await BudgetService.downloadItemPdf(itemKey) : await BudgetService.downloadSubcategoryPdf(subcategoryKey, file.objectKey);
            const url = window.URL.createObjectURL(res.data);
            const link = document.createElement("a"); link.href = url; link.download = file.fileName;
            document.body.appendChild(link); link.click(); link.remove(); window.URL.revokeObjectURL(url);
        } catch (e) { setError("ไม่สามารถดาวน์โหลดไฟล์ได้"); }
        finally { setBusy(false); }
    };
    if (subcategoryKey && !loading && !enabled && !error) return null;

    return <div className="mt-2 mb-2" style={{ fontWeight: "normal" }}>
        {loading ? <small>กำลังโหลดไฟล์...</small> : <>
            {files.map((file, index) => <div key={file.objectKey || index}><button type="button" className="btn btn-link p-0" disabled={busy} onClick={() => download(file)}>{file.fileName}</button></div>)}
            {pendingFiles.map((file, index) => <small key={index} className="d-block text-info">{file.name} — รออัปโหลดเมื่อบันทึก</small>)}
            {enabled && !readOnly ? <label className="d-block mt-2">{itemMode ? "แนบ PDF 1 ไฟล์ / อัปโหลดใหม่เพื่อแทนที่" : "แนบ PDF หลายไฟล์ (ไฟล์ส่วนกลางของหมวดย่อย)"}
                <input aria-label={itemMode ? `แนบ PDF รายการ ${itemKey || "ใหม่"}` : `แนบ PDF หมวดย่อย ${subcategoryKey}`} className="form-control-file" type="file" accept=".pdf,application/pdf" multiple={!itemMode} disabled={busy || disabled} onChange={upload} />
                <small className="text-muted">ไม่เกินไฟล์ละ 20 MB{subcategoryKey ? " ครั้งละไม่เกิน 5 ไฟล์" : ""}</small>
            </label> : null}
        </>}
        {busy && <small role="status">กำลังดำเนินการ...</small>}
        <BudgetFeedback message={message} type="success" />
        <BudgetFeedback message={error} />
    </div>;
}
